import script from "./VacacionesModal.vue?vue&type=script&setup=true&lang=js"
export * from "./VacacionesModal.vue?vue&type=script&setup=true&lang=js"

import "./VacacionesModal.vue?vue&type=style&index=0&id=a63e2938&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a63e2938"]])

export default __exports__